import { SVGProps } from "react"

type Props = SVGProps<SVGSVGElement> & {
  size?: number
}

export const IconSpinning = ({ size = 24, ...props }: Props) => (
  <svg
    id="spinning_svg__Calque_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 44 44"
    xmlSpace="preserve"
    width={size}
    height={size}
    {...props}
  >
    <style>
      {".spinning_svg__st2{fill:none;stroke:currentColor;stroke-width:2}"}
    </style>
    <defs>
      <filter
        id="spinning_svg__Adobe_OpacityMaskFilter"
        filterUnits="userSpaceOnUse"
        x={15.1}
        y={2.1}
        width={14}
        height={10.2}
      >
        <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
      </filter>
    </defs>
    <mask
      maskUnits="userSpaceOnUse"
      x={15.1}
      y={2.1}
      width={14}
      height={10.2}
      id="spinning_svg__path-1-inside-1_2140_76743_00000144340126497076064730000016088578236507785390_"
    >
      <path
        d="M17.1 5.8c0-1 .8-1.7 1.7-1.7h6.5c1 0 1.7.8 1.7 1.7v4.5H17V5.8z"
        style={{
          fill: "#fff",
          filter: "url(#spinning_svg__Adobe_OpacityMaskFilter)",
        }}
      />
    </mask>
    <path
      d="M17.1 5.8c0-1 .8-1.7 1.7-1.7h6.5c1 0 1.7.8 1.7 1.7v4.5H17V5.8z"
      style={{
        mask: "url(#spinning_svg__path-1-inside-1_2140_76743_00000144340126497076064730000016088578236507785390_)",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 4,
      }}
    />
    <path
      className="spinning_svg__st2"
      d="M16 34.1h12.2c1.3 0 2.4-1.2 2.2-2.5l-2.2-20.5c-.1-1.1-1.1-2-2.2-2h-7.8c-1.1 0-2.1.9-2.2 2l-2.2 20.5c-.2 1.3.9 2.5 2.2 2.5z"
    />
    <defs>
      <filter
        id="spinning_svg__Adobe_OpacityMaskFilter_00000060742686115959139710000013624386810250635187_"
        filterUnits="userSpaceOnUse"
        x={15.1}
        y={31.1}
        width={14}
        height={10}
      >
        <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
      </filter>
    </defs>
    <mask
      maskUnits="userSpaceOnUse"
      x={15.1}
      y={31.1}
      width={14}
      height={10}
      id="spinning_svg__path-3-inside-2_2140_76743_00000136386661218785215800000002347757062383020704_"
    >
      <path
        style={{
          fill: "#fff",
          filter:
            "url(#spinning_svg__Adobe_OpacityMaskFilter_00000060742686115959139710000013624386810250635187_)",
        }}
        d="M27.1 37.4c0 .9-.8 1.7-1.7 1.7h-6.5c-1 0-1.7-.8-1.7-1.7v-4.3h10v4.3z"
      />
    </mask>
    <path
      d="M27.1 37.4c0 .9-.8 1.7-1.7 1.7h-6.5c-1 0-1.7-.8-1.7-1.7v-4.3h10v4.3z"
      style={{
        mask: "url(#spinning_svg__path-3-inside-2_2140_76743_00000136386661218785215800000002347757062383020704_)",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 4,
      }}
    />
    <path
      className="spinning_svg__st2"
      d="m14 24.7 16.9 4.7M14.2 19l16 4.5M15.1 12.8 29 16.6"
    />
  </svg>
)
